import { formatDate } from '../utils/dateFormatter';

export default function TermsPage() {
    return (
        <div className="min-h-screen bg-black text-gray-300 py-20 px-6">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-4xl font-bold text-white mb-8">Terms of Service</h1>
                <p className="mb-4">Last updated: {formatDate(new Date())}</p>

                <section className="mb-8">
                    <h2 className="text-2xl font-semibold text-white mb-4">1. Introduction</h2>
                    <p className="mb-4">
                        Welcome to Stellar. By accessing or using our website and services, you agree to be bound by these Terms of Service.
                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-2xl font-semibold text-white mb-4">2. Use of Service</h2>
                    <p className="mb-4">
                        Stellar provides team engagement tools including Bingo games and Leave tracking. You agreed to use these services only for lawful business purposes.
                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-2xl font-semibold text-white mb-4">3. Account Responsibilities</h2>
                    <p className="mb-4">
                        You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
                    </p>
                </section>

                <div className="mt-12 border-t border-gray-800 pt-8">
                    <a href="/landing" className="text-purple-400 hover:text-purple-300">← Back to Home</a>
                </div>
            </div>
        </div>
    );
}
